import { FontType, TextAlign } from '@modusign/react-signing/types';

import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import DateFieldPlaceholder from '@app/features/apply-react-signing/components/FieldSetupStep/Placeholders/DateFieldPlaceholder';
import { useTransformTextStyle } from '@app/features/apply-react-signing/libs/hooks/useTransFormTextStyle';
import PDFFontNormalizer from '@app/libs/reactPdfJs/utils/PDFFontNormalizer';

interface DateFieldMousePlaceholderProps {
  size: AbsoluteSize;
  fontFamily: FontType;
  fontSize: number;
  required: boolean;
  textAlign: TextAlign;
  participantOrder: number;
  dateFormat: string;
  scale: number;
}

const defaultProps = {
  latestFieldData: null,
  participantOrder: 1,
  scale: 1,
};

function DateFieldMousePlaceholder({
  dateFormat,
  size,
  fontFamily,
  fontSize,
  required,
  textAlign,
  participantOrder,
  scale,
}: DateFieldMousePlaceholderProps) {
  const fontPixelSize = PDFFontNormalizer.toPixelFontSize({ fontSize }, scale);
  const { transformTextStyle } = useTransformTextStyle({
    size,
    fontFamily,
    fontSize,
    textAlign,
    scale,
  });

  return (
    <DateFieldPlaceholder
      dateFormat={dateFormat}
      fontPixelSize={fontPixelSize}
      participantOrder={participantOrder}
      rootElementSize={size}
      star={required}
      style={transformTextStyle}
    />
  );
}

DateFieldMousePlaceholder.defaultProps = defaultProps;

export default DateFieldMousePlaceholder;
